export { AddDevicePage } from './AddDevicePage'
